import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SearchUsageReport from '../../components/report/SearchUsageReport'
import { translate } from 'react-polyglot'
import { setFilters, initializeSearch, resetFilters } from '../../actions/search/search'
import { openModal } from '../../actions/common'
import { fetchUsageList, fetchUsageInfo, downloadUsageList, downloadUsageInfo, clearSearch, clearDynamicFilters, clearSearchResultList } from '../../actions/reports/usageReport'
import { fetchUsageProcessTypesCombo, fetchUserCombo, fetchOrganizedUnitsAcceptClientsCombo } from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.usageReport,
    combos: {
      UOAcceptClientsCombo: state.combos.UOAcceptClientsCombo,
      usageProcessTypesCombo: state.combos.usageProcessTypesCombo,
      usersCombo: state.combos.usersCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchUsageList,
      fetchUsageInfo,
      downloadUsageList,
      downloadUsageInfo,
      fetchUsageProcessTypesCombo,
      fetchUserCombo,
      fetchOrganizedUnitsAcceptClientsCombo,
      setFilters,
      resetFilters,
      initializeSearch,
      openModal,
      clearSearch,
      clearDynamicFilters,
      clearSearchResultList
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SearchUsageReport))
